import { BrowserRouter, Routes,Route } from "react-router-dom";
import NexusForge from "./Pages/MerchantForm/NexusForge";
import './output.css';
import Fixit from "./Pages/MerchantForm/Fixit";
import IFrameTest from "./Pages/MerchantForm/IFrameTest";
import KhubaibFoundation from "./Pages/MerchantForm/KhubaibFoundation";
import DarUlSukoonDonation from "./Pages/MerchantForm/DarUlSukoon/DarUlSukoonDonation";
import DarUlSukoonZakat from "./Pages/MerchantForm/DarUlSukoon/DarUlSukoonZakat";
import JTQDonation from "./Pages/MerchantForm/JTQ/JTQDonation";
import JTQZakat from "./Pages/MerchantForm/JTQ/JTQZakat";
import RMIForm from "./Pages/MerchantForm/RMI/RMIForm";
import JHRTrust from "./Pages/MerchantForm/JHRTrust";
import QNQFoundation from "./Pages/MerchantForm/QNQFoundation";
import NDF from "./Pages/MerchantForm/NDF";
import NjvSchool from "./Pages/MerchantForm/Njv/NjvSchool";
import PDSA from "./Pages/MerchantForm/PDSA";
import DeactiveAccount from "./Pages/DeactiveAccount";
import ZuberiAssociation from "./Pages/MerchantForm/ZuberiAssociation";
import AkberKare from "./Pages/MerchantForm/AkberKare";
import WDOPakistan from "./Pages/MerchantForm/WDOPakistan";
import DonationForm from "./Pages/MerchantForm/DonationForm";
import RMIEducation from "./Pages/MerchantForm/RMI/RMIEducation";
import UmeedGahWelfare from "./Pages/MerchantForm/UmeedGahWelfare";
import AmourFoundation from "./Pages/MerchantForm/AmourFoundation";
import Finiz from "./Pages/MerchantForm/Finiz";
import HandleResponse from "./Pages/MeezanBank/HandleResponse";
import FlagLog from "./Component/FlagLog";
import PayProCircularLoader from "./Component/PayProCircularLoader";
import IPCIH from "./Pages/MerchantForm/IPCIH";
import SmileFoundation from "./Pages/MerchantForm/SmileFoundation";
import LessonLearn from "./Pages/MerchantForm/LessonLearn";
import HansotiesFoundation from "./Pages/MerchantForm/HansotiesFoundation";
import GamcaMedicalDollar from "./Pages/MerchantForm/GamcaMedical/GamcaMedicalDollar";
import GamcaMedicalPkr from "./Pages/MerchantForm/GamcaMedical/GamcaMedicalPkr";
function App() {
  return (
      <BrowserRouter >
        <Routes>
          <Route path="/merchantform/nexusforge" element={<NexusForge />} />
          <Route path="/merchantform/fixit" element={<Fixit />} />
          <Route path="/merchantform/jhrtrust" element={<JHRTrust />} />
          <Route path="/merchantform/khubaib-foundation" element={<KhubaibFoundation />} />
          <Route path="/merchantform/DarUlSukoon/Donation" element={<DarUlSukoonDonation />} />
          <Route path="/merchantform/DarUlSukoon/Zakat" element={<DarUlSukoonZakat />} />
          <Route path="/merchantform/JTQ/Donation" element={<JTQDonation />} />
          <Route path="/merchantform/JTQ/Zakat" element={<JTQZakat />} />
          {/*<Route path="/merchantform/RMI" element={<RMIForm />} />*/}
          <Route path="/merchantform/RMI-education" element={<RMIEducation />} />
            <Route path="/merchantform/QNQ-foundation" element={<QNQFoundation />} />
            <Route path="/merchantform/ndf" element={<NDF />} />
            <Route path="/merchantform/njv-school" element={<NjvSchool />} />
            <Route path="/merchantform/pdsa" element={<PDSA />} />
            <Route path="/merchantform/zubari-associate" element={<ZuberiAssociation />} />
            <Route path="/merchantform/akbar-kare" element={<AkberKare />} />
            <Route path="/merchantform/wdo-pakistan" element={<WDOPakistan />} />
              <Route path="/merchantform/umeedwelfare" element={<UmeedGahWelfare />} />
              <Route path="/merchantform/amour-foundation" element={<AmourFoundation />} />
              <Route path="/merchantform/finiz" element={<Finiz />} />
              <Route path="/merchantform/ipchih" element={<IPCIH />} />
              <Route path="/merchantform/smile-foundation" element={<SmileFoundation />} />
              <Route path="/merchantform/lesson-learn" element={<LessonLearn />} />
              <Route path="/merchantform/hansoties-foundation" element={<HansotiesFoundation />} />
              <Route path="/merchantform/gamcamdeical-dollar" element={<GamcaMedicalDollar />} />
              <Route path="/merchantform/gamcamdeical-pkr" element={<GamcaMedicalPkr />} />
            <Route path="merchant/deactive_package_or_account" element={<DeactiveAccount />} />
            <Route path="donationformtest" element={<DonationForm />} />
          <Route path="/iframetest" element={<IFrameTest />} />
          {/*<Route path="/" element={<PayProCircularLoader />} />*/}
          {/*<Route path="/mbl/request_pay" element={<HandleResponse />} />*/}
        </Routes>
      </BrowserRouter>

  );
}

export default App;
